module.exports = __webpack_public_path__ + "static/img/FI.e0cf9e4f.svg";